import axios from "./AxiosWrapper";
import queryString from "query-string";
import { INVOICING } from "../state/actions/orderActions";
import config from "../config";

const mapAdditionalFields = fieldsObject => {
  return Object.keys(fieldsObject)
    .map((key, index) => {
      const value = fieldsObject[key];
      return {
        questionId: key,
        value: value
      };
    })
    .filter(q => q.value !== null);
};

const OrderService = {
  get(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${config("API_URL")}order/${id}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  addDiscount(eventId, orderId, discountCode) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}discounts/add`, {
          eventId,
          orderId,
          discountCode
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async getPublicOrder(eventId, orderId, token) {
    const response = await axios.get(
      `${config(
        "API_URL"
      )}public/edit-order/order/${orderId}/${eventId}/${token}`
    );
    return response.data;
  },
  async savePublicOrder(eventId, orderId, token, orderData) {
    const response = await axios.post(
      `
    ${config("API_URL")}public/edit-order/order/${orderId}/${eventId}/${token}`,
      orderData
    );
    return response.data;
  },
  async addGiftCard(eventId, orderId, giftCardCode) {
    const response = await axios.post(`${config("API_URL")}gift-cards/add`, {
      eventId,
      orderId,
      giftCardCode
    });
    return response.data;
  },

  async completeOrderWithGiftCard(orderId) {
    const response = await axios.post(
      `${config("API_URL")}gift-cards/complete`,
      {
        orderId
      }
    );
    return response.data;
  },

  async removeGiftCard(orderId) {
    const response = await axios.post(`${config("API_URL")}gift-cards/remove`, {
      orderId
    });
    return response.data;
  },
  removeDiscount(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}discounts/remove`, {
          orderId
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  summary(
    id,
    requestedTickets,
    clientDonation,
    order,
    merch,
    giftCard,
    isEventId,
    tipFees,
  ) {
    const orderId = order && order.data && order.data._id ? order.data._id : false;
    const tickets = order && order.tickets ? order.tickets.map(ticket => {
      if (!ticket.quantity) {
        return { ...ticket, quantity: 1 }
      }
      return ticket
    }) : requestedTickets;
    const isInvoice = order && order.paymentMethod === INVOICING;
    let isManualOrder = false;
    if (window) {
      isManualOrder =
        window.manualOrderToken &&
          window.isManualOrder &&
          window.manualOrderSettings ? true : false;
    }
    const ticketsWithQuantity = (tickets) ? tickets.filter(ticket => {
      return isNaN(ticket.quantity) || ticket.quantity > 0 ? true : false;
    }) : [];
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config("API_URL")}order${!isEventId ? "/global" : ""}/summary`,
          {
            [isEventId ? "eventId" : "userId"]: id,
            tickets: ticketsWithQuantity,
            merch: merch ? merch : [],
            giftCard: giftCard ? giftCard : [],
            clientDonation,
            isInvoice,
            orderId,
            isManualOrder,
            tipFees
          }
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  request(
    id,
    eventDateId,
    requestedItems,
    discountCode,
    clientDonation,
    lastOrderId,
    isGlobal,
    manualOrderValues
  ) {
    const isBrowser = typeof window !== "undefined";
    let offerId;
    if (isBrowser) {
      const parsed = queryString.parse(window.location.search);
      // get the offer id for waitlist clients
      offerId = parsed.offerid;
    }
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config("API_URL")}order${isGlobal ? "/global" : ""}/request`,
          {
            [!isGlobal ? "eventId" : "userId"]: id,
            eventDateId,
            [!isGlobal
              ? "requestedTickets"
              : "requestedGiftCards"]: requestedItems,
            discountCode,
            clientDonation,
            lastOrderId,
            offerId
          },
          { params: manualOrderValues }
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveDetails(orderData, tickets, ticketsData, hasAdditionalSteps, isGlobal) {
    let manualOrderSettings;
    if (window.manualOrderSettings) {
      manualOrderSettings = window.manualOrderSettings;
    }
    orderData.additionalFields = orderData.additionalFields
      ? mapAdditionalFields(orderData.additionalFields)
      : orderData.additionalFields;
    // merge ticket additional fields
    const ticketLookUp = {};
    tickets.forEach((ticket, index) => {
      ticketLookUp[ticket._id] = index;
    });
    if (isGlobal) {
      ticketsData.forEach(giftCard => {
        const index = ticketLookUp[giftCard.giftCardId];
        let giftCardLookup = tickets[index];
        if (giftCardLookup) {
          tickets[index] = { ...giftCardLookup, ...giftCard };
        }
      });
    } else if (ticketsData) {
      Object.keys(ticketsData).map((key, index) => {
        let ticket = tickets[ticketLookUp[key]];
        if (ticket) {
          ticket.additionalFields = mapAdditionalFields(ticketsData[key]);
        }
      });
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}order/${isGlobal ? "global/" : ""}details`, {
          orderData,
          [isGlobal ? "giftCardData" : "ticketData"]: tickets,
          hasAdditionalSteps: hasAdditionalSteps,
          manualOrderSettings
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  saveAfterCheckoutQuestions(eventId, orderData, tickets, ticketsData) {
    orderData.additionalFields = orderData.additionalFields
      ? mapAdditionalFields(orderData.additionalFields)
      : orderData.additionalFields;
    const ticketLookUp = {};
    tickets.forEach((ticket, index) => {
      ticketLookUp[ticket._id] = index;
    });
    if (ticketsData) {
      Object.keys(ticketsData).map((key, index) => {
        let ticket = tickets[ticketLookUp[key]];
        if (ticket) {
          ticket.additionalFields = mapAdditionalFields(ticketsData[key]);
        }
      });
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}order/afterCheckout`, {
          eventId,
          orderData,
          ticketData: tickets
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  pay(orderId, gateway, details, eventId, isGlobal, tipFees) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}order/pay`, {
          orderId,
          gateway,
          details,
          eventId,
          isGlobal,
          tipFees
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  attendeeActionedRefund(refundRequestObj, token) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}public/attendee-actioned-refund/${token}`, {
          ...refundRequestObj
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addToCalendar(values) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${config("API_URL")}order/add-to-calendar`, { ...values })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};
export default OrderService;
